'use client';
import { Toaster } from 'sonner';

export default function ToasterSetup() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '14px',
        },
      }}
    />
  );
}